module.exports = __webpack_public_path__ + "img/race-suit.fd63fdf8.png";